var PriceAlert = {
    countryCode:'TR',

    setCountryCode: function(code){
        var code = code.toUpperCase();
        if(code=='INTBUT'){ //international site icin flag.country bu sekilde geliyor.
            code='TR';
        }
        this.countryCode = code;
    }
};

$(document).ready(function() {
    initializePriceAlert();
});

function initializePriceAlert() {


    if (flightSelectedAndHasResult){
        $('#selectPriceAlertData').remove();
        setSelectedFlightPriceAlertDate();
    }
    else{
        $('#selectedFlightPriceAlertData').remove();
    }


    $( "#priceAlert" ).dialog({
        autoOpen: false,
        width : 700,
        height : 600,
        modal : true,
        show: "fade",
        hide: "fade",
        dialogClass : 'price-alert',
        resizable : false,
        draggable : false
    });

    $( ".priceAlertLink" ).click(function() {
        $( "#priceAlert" ).dialog( "open" );
        if ($("#isResultPage").val() == 'false' || $("#isResultPage").val()== '' ){
            $("#pa-popupType" ).val("1");
        }else{
            $("#pa-popupType" ).val("2");
        }
    });


    $(".ui-dialog-titlebar-close").removeAttr("title");

    $("#priceAlert").on('dialogclose', function(event) {
        if($("#isResultPage").val() == 'false' || $("#isResultPage").val()== ''){
            $('#pa-fromAirport').val("");
            $('#pa-fromAirportId').val("");
            $('#pa-toAirport').val("");
            $('#pa-toAirportId').val("");
            $('#pa-departureDate').val("");
            $('#pa-returnDate').val("");
            $("#pa-email").val("");
            $("#pa-gsm").val("");
            $("#pa-radio1").attr("checked","checked");
        }
        $(".priceAlertBtn").show();
        $('#pa-processfail').hide();
        $('#processsuccess').hide();
    });

    if($("#isResultPage").val() == 'false' || $("#isResultPage").val()== '' ){
        $("#pa-paxADT").val("1");
        $("#pa-paxCHD").val("0");
        $("#pa-paxINF").val("0");
    }

    //autocomplete
    $(".airportAutoComplete").autocomplete({
        source : function(request, response) {
            $.ajax({
                url : "/airports",
                dataType : "json",
                data : {
                    output : 'json',
                    results : 100,
                    query : request.term
                },
                success : function(data) {

                    if ($("#divCityBoxDep").length)
                        $("#divCityBoxDep").hide();

                    if ($("#divCityBoxRet").length)
                        $("#divCityBoxRet").hide();

                    response($.map(data.ResultSet.Result.slice(0,10), function(item) {
                        return {
                            value :  item.CityName + ", " + item.Name + " (" + item.Code + "), " + item.CountryCode,
                            id : item.id,
                            atype: item.type,
                            name : item.Name,
                            cityName: item.CityName,
                            countryName: item.CountryName,
                            countryCode : item.CountryCode,
                            airports : item.airports,
                            city : item.CityCode
                        };
                    }));
                }
            });
        },
        select : function(event, ui) {
            $('[name="' + $(this).attr('name') + 'Id"]', this.form).val(ui.item.id);
            if (ui.item.city) {
                $('[name="' + $(this).attr('name') + 'City"]', this.form).val(ui.item.city);
            }else if (ui.item.CityCode) {
                $('[name="' + $(this).attr('name') + 'City"]', this.form).val(ui.item.CityCode);
            }
            $(this).data('autoCompleteId', ui.item.id);

            $.cookie($(this).attr('name'), JSON.stringify(ui.item), { expires : 365, path : '/' });

        },
        minLength : 3
    }).change(function(event) {
        var item = {value: this.value, id: '', city:''};
        $.cookie($(this).attr('name'), JSON.stringify(item), { expires : 365, path : '/' });
    });

    $(".airportAutoComplete").click(function() {
        $(this).select();
    });


    $( ".pa-spinnerTravelerADT" ).spinner({
        min: 1,
        max: 6
    });
    $( ".pa-spinnerTravelerCHD" ).spinner({
        min: 0,
        max: 4
    });
    $( ".pa-spinnerTravelerINF" ).spinner({
        min: 0,
        max: 3
    });

    $(".pa-spinnerTravelerADT, .pa-spinnerTravelerCHD, .pa-spinnerTravelerINF").change(function(){
        var paxADT = $( "[name=pa-paxADT]" ).spinner( "value" );
        var paxCHD = $( "[name=pa-paxCHD]" ).spinner( "value" );
        var paxINF = $( "[name=pa-paxINF]" ).spinner( "value" );
        try {
            $.cookie('numAdultFlight', paxADT, { expires : 365, path : '/' });
            $.cookie('numChildFlight', paxCHD, { expires : 365, path : '/' });
            $.cookie('numInfantFlight', paxINF, { expires : 365, path : '/' });
        } catch (e) {
        }
        var totalPax = paxADT + paxCHD + paxINF;
        $(".pa-travelerSelectPax").html(totalPax);
        var locale = $.cookie('siteLocale');
        if(locale == "en"){
            if(totalPax > 1){
                $(".travelerFmt").html(travelersMessage);
            }else{
                $(".travelerFmt").html(travelerMessage);
            }
        }else if(locale == "ru" || locale == "ua"){
            var partLast2 = totalPax % 100;
            var partLast1 = totalPax % 10;
            if(partLast1 == 0 || (partLast1 >= 5 && partLast1 <= 9) || (partLast2 >= 11 && partLast2 <= 14)){
                $(".travelerFmt").html(travelerMessageRu3);
            }else if(partLast1 == 1){
                $(".travelerFmt").html(travelerMessageRu1);
            }else if(partLast1 >= 2 && partLast1 <= 4){
                $(".travelerFmt").html(travelerMessageRu2);
            }
        }else{
            $(".travelerFmt").html(travelerMessage);
        }
    });


    $(".pa-spinnerTravelerADT, .pa-spinnerTravelerCHD, .pa-spinnerTravelerINF").on("spinstop",function(){
        $(this).change();
    });


    $(".pa-travelerSelectlink").click(function() {
        $('.pa-travelerList').toggle("fade","fast");
        return false;
    });
    $('body, .pa-classSelectlink').click(function(event) {
        if (!$(event.target).closest('.pa-travelerList').length) {
            $('.pa-travelerList').hide();
        };
    });

    $(".pa-classSelectlink").click(function() {
        $('.pa-classList').toggle("fade","fast");
        return false;
    });
    $('body, .pa-travelerSelectlink').click(function(event) {
        if (!$(event.target).closest('.pa-classList').length) {
            $('.pa-classList').hide();
        };
    });

    $(".pop-close-btn").click(function() {
        $('.pa-classList, .pa-travelerList').hide();
        return false;
    });

    $( "#pa-radioDirections").buttonset();
    $( "#pa-fclass").buttonset();

    $("[name=pa-fclass]").change(function(){
        var id = this.id;
        var $label = $("[for=" + id + "]");
        $(".pa-classSelectlink").html($label.find("span").html());
        $('.pa-classList').hide();
    });

    $("[name='pa-direction']").change(function() {
        var value = $(this).val();
        if (value == "1") {
            $(".pa-returnDate").attr("disabled", "disabled");
        } else {
            $(".pa-returnDate").removeAttr("disabled");

        }
    });

    $(".dateTo2").on("click", function() {
        $("[name='pa-direction'][value='2']").click();
        $(".pa-returnDate").removeAttr("disabled");
        $("#pa-returnDate").datepicker("show");

    });

    var datePickerDateFormatDD = "dd.mm.yy";
    var now = new Date();
    var aYearLater = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());
    $(".pa-departureDate").datepicker({ //Sadece ilk date pickerlar update oluyor, ilklerinden degerler alınarak set ediliyor.
        dateFormat : datePickerDateFormatDD,
        dayNames : DateLongNames.day,
        numberOfMonths : 1,
        minDate : new Date(),
        maxDate : aYearLater,
        onSelect : function(dateText, inst) {
            var minDate = $.datepicker.parseDate(datePickerDateFormat, dateText.substr(0,10));
            var endDateStr = $("#pa-returnDate").val();
            var endDate = null;
            if (endDateStr != "")
                endDate = $.datepicker.parseDate(datePickerDateFormat, endDateStr.substr(0,10));
            minDate.setDate(minDate.getDate());
            $(".pa-returnDate").datepicker("option", "minDate", minDate);
            setDateValueToCookie('pa-returnDateFlight', $("#pa-returnDate").val());
            if (endDateStr == "" || minDate.getTime() >= endDate.getTime()) {
                var newEndDate = new Date(minDate);
                newEndDate.setDate(newEndDate.getDate() + 6);
                $(".pa-returnDate").datepicker("setDate", newEndDate);
                setDateValueToCookie('pa-returnDateFlight', $("#pa-returnDate").val());
            }
            setDateValueToCookie('pa-departureDateFlight', dateText);
        },

        onClose : function(dateText, inst) {
            var value = $("#pa-departureDate").val(); // Birden fazla datepicker icin onemli !!!!
            $(".pa-departureDate").val(value);
            if (2 == $('input[name=direction]:checked').val()) {
                setTimeout(function() {
                    var context = inst.input.parent().parent();
                    $('#pa-returnDate',context).blur();
                    $("#pa-returnDate",context).datepicker("show");
                }, 100);
            }
        }
    });

    var datePickerDateFormat = "dd.mm.yy";

    var currentDate = $.datepicker.formatDate(datePickerDateFormat, now);

    $('#pa-departureDate').val(currentDate);
    datepickerGoToToday();




    var minDatePa = null;
    var minDateStrPa = $("#pa-departureDate").val();
    if(minDateStrPa){
        minDateStrPa == "" ? minDatePa = new Date() : minDatePa = $.datepicker.parseDate(datePickerDateFormat, minDateStrPa.substr(0,10));
        minDatePa.setDate(minDatePa.getDate());
        var maxDatePa = new Date();
        maxDatePa.setFullYear(minDatePa.getFullYear() + 1);
    }
    $(".pa-returnDate").datepicker({
        dateFormat : datePickerDateFormatDD,
        dayNames : DateLongNames.day,
        numberOfMonths : 1,
        minDate : minDatePa,
        maxDate : maxDatePa,
        onClose : function(dateText, inst) {
            var value = $("#pa-returnDate").val(); // Birden fazla datepicker icin onemli !!!!
            $(".pa-returnDate").val(value);
            setDateValueToCookie('pa-returnDateFlight', value );
        }
    });

    $(".pa-departureDate").keypress(function(event) {
        var currentDate = $(this).val();
        try {
            var d = $.datepicker.parseDate(datePickerDateFormat, currentDate.substr(0,10));
            d.setDate(d.getDate() + 6);
            $(".pa-returnDate").datepicker("setDate", d);
            setDateValueToCookie('pa-departureDateFlight', currentDate);
            setDateValueToCookie('pa-returnDateFlight', $("#pa-returnDate").val());
        } catch (e) {
        }
    });

    setDateValueToCookie('pa-departureDateFlight', $("#pa-departureDate").val());
    setDateValueToCookie('pa-returnDateFlight', $("#pa-returnDate").val());

    function setDateValueToCookie(name, value) {
        try {
            $.cookie(name, value.substr(0,10), { expires : 365, path : '/' });
        } catch (e) {
        }
    }

    if(siteId == 1){
        $("#pa-gsm").mask("(999) 999-9999");
    }else{
        $("#pa-gsm").mask("999999999?999999");
    }

    $("#pa-gsm_code").intlTelInput({
        preferredCountries: [PriceAlert.countryCode],
        americaMode: false
    });



    $("#pa-gsm_code").focusout(function(){
        var isTR = $("#pa-gsm_code").val().includes("+90");
        if(isTR){
            $("[name=gsm]").mask("(999) 999-9999");
        }else{
            $("[name=gsm]").mask("999999999999999");
        }
    });

    var priceAlertSuggested=false;

    $("#header").mouseover(function(e) {
        if (!priceAlertSuggested && showPriceAlert == 0) {
            priceAlertSuggested = true;
            $( "#pa-popupType" ).val('3');
            $( "#priceAlert" ).dialog( "open" );
        }
    });

    $( "#btnPriceAlert" ).click(function() {
        var isvalid = $("#priceAlertForm").valid();

        if (!isvalid){
            $(".priceAlertBtn").show();
            return false;
        }
	    var selectedLang = $("<input>").attr("type", "hidden").attr("name", "selectedLang").val($.cookie('siteLocale'));
	    $('#priceAlertForm').append($(selectedLang));

//		şimdilik subscription kabul etmesi gerekmiyor.
// 		if(!checkSubscriptionStatus()){
// 			alert(msgSubscription);
// 			return false;
// 		}

        $(".priceAlertBtn").addClass("btn-loading");

        openLoaderBox();
        createPriceAlertAjax();
    });

    $( ".newAlert" ).click(function() {
        $(".alert-msg").slideToggle("fast");
    });

}

function createPriceAlertAjax(){
    $.ajax({
        type : "POST",
        async : true,
        url : "/flight/priceAlert",
        data : $('#priceAlertForm').serialize(),
        dataType : 'json',
        success : function(response) {

            $(".priceAlertBtn").removeClass("btn-loading");
            closeLoaderBox();
            if (response.hasError) {
                $('#pa-processfail').html(response.errorMessage + "<br /><br /> " + response.errorCode);
                $('#pa-processfail,.alert-msg').show();
                $('#processsuccess').hide();

                return;
            }else {
                $('#processsuccess').html(msgAlertSuccess);
                $('#processsuccess,.alert-msg').show();
                $('#pa-processfail').hide();
                return;
            }
        },
        error : function(xhr, ajaxOptions, errorThrown) {
            closeLoaderBox();
        }

    });
}

function switchAirportsPa() {
    var fromAirport = $("[name=pa-fromAirport]").val();
    var toAirport = $("[name=pa-toAirport]").val();
    var fromAirportId = $("[name=pa-fromAirportId]").val();
    var toAirportId = $("[name=pa-toAirportId]").val();
    $("[name=pa-fromAirport]").val(toAirport);
    $("[name=pa-toAirport]").val(fromAirport);
    $("[name=pa-fromAirportId]").val(toAirportId);
    $("[name=pa-toAirportId]").val(fromAirportId);
}

function checkSubscriptionStatus(){
    var agree = $('#subscription').prop("checked");
    if (agree) {
        return true;
    }else{
        return false;
    }
}

function datepickerGoToToday(){

    var o_gotoToday = $.datepicker._gotoToday;

    $.datepicker._gotoToday = function(id) {

        o_gotoToday.call(this, id);
        var date = new Date();
        var selDate  = this.formatDate("dd.mm.yy", date);
        this._selectDate(id, selDate);

    }
}

function setSelectedFlightPriceAlertDate() {
    $('#pa-fromAirport').val(FlightPriceAlertData.fromAirportText);
    $('#pa-fromAirportId').val(FlightPriceAlertData.fromAirportId);
    $('#pa-toAirport').val(FlightPriceAlertData.toAirportText);
    $('#pa-toAirportId').val(FlightPriceAlertData.toAirportId);
    $('#pa-departureDate').val(FlightPriceAlertData.departureDateFormattedLong);

    if (FlightPriceAlertData.returnDateFormattedLong) {
        $('#pa-returnDate').val(FlightPriceAlertData.returnDateFormattedLong);
    }
    $('#pa-paxADT').val(FlightPriceAlertData.numAdult);
    $('#pa-paxCHD').val(FlightPriceAlertData.numChild);
    $('#pa-paxINF').val(FlightPriceAlertData.numInfant);
    $('#pa-fclass').val(FlightPriceAlertData.fclass);

    $('#pa_departureMinPrice').val(FlightPriceAlertData.departureMinPrice);
    $('#pa_returnMinPrice').val(FlightPriceAlertData.returnMinPrice);

    if (FlightPriceAlertData.source){
        $('[name=pa-source]').val(FlightPriceAlertData.source);
    }
    else{
        $('[name=pa-source]').remove();
    }

    $("#flightTypeText").html(FlightPriceAlertData.fclassText);
    $("#flightDirection").html(FlightPriceAlertData.directionText);
    var totalTraveller = FlightPriceAlertData.numAdult + FlightPriceAlertData.numChild + FlightPriceAlertData.numInfant;
    $("#totalTraveler").text(totalTraveller);

    var dates = FlightPriceAlertData.departureDateFormattedLong;

    if (FlightPriceAlertData.returnDateFormattedLong){
        dates += ' - ' + FlightPriceAlertData.returnDateFormattedLong;
    }
    $('.pa-flight-dates').html(dates)

    var flightRouteDeparture = FlightPriceAlertData.fromAirportCityName + ' ' + FlightPriceAlertData.fromAirportText;
    var flightRouteArrival = FlightPriceAlertData.toAirportCityName + ' ' + FlightPriceAlertData.toAirportText;
    var route = flightRouteDeparture + ' - ' + flightRouteArrival;
    $('.pa-flight-route').text(route)

}